import {
    allowCookies,
    identifyUser,
  } from "../../services/mixpanel"

import {
    getUserEmail,
    } from "../../services";

  // Set up reducer and apply Object Spread operator to update it
export function reducerUserContext(userState, action) {
    switch (action.type) {
        case "SET_COOKIES_ALLOWANCE":
          if (action.payload) {
              identifyUser(getUserEmail(), true);
          };
          return {
            ...userState,
            allowedCookies: action.payload,
          };
        case "SET_USER_LOGGED_IN":
          allowCookies(); //If user logged has accepted terms so we start tracking
          return {
            ...userState,
            isUserLoggedIn: action.payload,
            };
        case "SET_STRIPE_LEVEL":
          return {
            ...userState,
            userStripeLevel: action.payload,
            };
        case "SET_PREF_UNITS":
          console.log("user pref units in userState");
          return {
            ...userState,
            userPrefUnits: action.payload,
          };
        case "SET_ACTIVITY_UUID":
          console.log("activity uuid updated" + action.payload);
          return {
            ...userState,
            activityUuid: action.payload,
          };
          case "SET_ACTIVITY_ID":
            console.log("activity id updated: " + action.payload);
            return {
              ...userState,
              activityId: action.payload,
            };
        default:
          return userState;
    }
}